import Modal from "bootstrap/js/dist/modal";

document.documentElement.classList.add("js-enabled");

const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
).matches;

function observeReveal(elements, options = {}) {
    const {
        threshold = 0.1,
        rootMargin = "0px 0px 50px 0px",
        delayPerItem = 0,
        delayModulo = 0,
    } = options;

    if (!elements.length) {
        return;
    }

    const shouldAnimateImmediately =
        prefersReducedMotion || typeof IntersectionObserver === "undefined";

    if (shouldAnimateImmediately) {
        elements.forEach((element) => {
            element.classList.add("animate-in");
        });
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("animate-in");
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            root: null,
            threshold,
            rootMargin,
        },
    );

    elements.forEach((element, index) => {
        if (delayPerItem > 0) {
            const delayIndex = delayModulo > 0 ? index % delayModulo : index;
            element.style.animationDelay = `${delayIndex * delayPerItem}s`;
        }

        observer.observe(element);
    });
}

function animateEntryElements(elements, options = {}) {
    const { delayStep = 0.1 } = options;

    if (!elements.length) {
        return;
    }

    if (prefersReducedMotion) {
        elements.forEach((element) => {
            element.classList.add("animate-in");
        });
        return;
    }

    window.requestAnimationFrame(() => {
        elements.forEach((element, index) => {
            element.style.animationDelay = `${index * delayStep}s`;
            element.classList.add("animate-in");
        });
    });
}

function animateEntryElementGroups(groups = []) {
    if (!groups.length) {
        return;
    }

    groups.forEach((group) => {
        animateEntryElements(group.elements, {
            delayStep: group.delayStep,
        });
    });
}

//gallery modal
document.querySelectorAll(".gallery-item").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const fullImg = item.getAttribute("href");
        document.getElementById("modalImage").src = fullImg;
        const modal = new Modal(document.getElementById("galleryModal"));
        modal.show();
    });
});

//close the modal on click
function closeModal() {
    const galleryModalElement = document.getElementById("galleryModal");
    if (!galleryModalElement) {
        return;
    }
    galleryModalElement.addEventListener("click", () => {
        const myModal = Modal.getInstance(galleryModalElement);
        myModal.hide();
    });
}
closeModal();

//gallery page load more
//The hidden items carry their thumbnail URL and alt text on the anchor (data-gallery-src /
//data-gallery-alt) and hold no <img>, so image-optimizer plugins have nothing to rewrite. The
//fallbacks below cover markup produced by the older template, which may still be sitting in a
//plugin's HTML cache: such an <img> has had its data-src consumed and re-published under a
//plugin-private name.
const GALLERY_SRC_ATTRS = [
    "data-src",
    "data-wpc-qw-src",
    "data-wpc-fb",
    "data-lazy-src",
];

function galleryThumbUrl(hiddenItem) {
    const own = hiddenItem.getAttribute("data-gallery-src");
    if (own) {
        return own;
    }
    const img = hiddenItem.querySelector("img");
    if (!img) {
        return null;
    }
    for (const attr of GALLERY_SRC_ATTRS) {
        const value = img.getAttribute(attr);
        if (value) {
            return value;
        }
    }
    //a real src that is not a placeholder is already usable
    const src = img.getAttribute("src");
    return src && src.indexOf("data:") !== 0 ? src : null;
}

document.querySelectorAll("#gallery-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        //get the hidden gallery items
        const hiddenItems = document.querySelectorAll(".gallery-item.d-none");
        if (!hiddenItems.length) {
            return;
        }
        let revealed = 0;
        //loop through the hidden items and show them
        hiddenItems.forEach((hiddenItem) => {
            const thumbUrl = galleryThumbUrl(hiddenItem);
            if (!thumbUrl) {
                return;
            }
            //build the image if the item does not already carry one
            let img = hiddenItem.querySelector("img");
            if (!img) {
                img = document.createElement("img");
                img.alt = hiddenItem.getAttribute("data-gallery-alt") || "";
                hiddenItem.appendChild(img);
            }
            //set the src attribute
            img.src = thumbUrl;
            //remove the hidden class
            hiddenItem.classList.remove("d-none");
            revealed += 1;
        });
        //only retire the button if it actually did something: a silent failure here reads as a
        //caching bug, a button that stays put reads as the bug it is
        if (revealed) {
            item.remove();
        }
    });
});

//accordion
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
    });
}

//modify the functionality of the main menu with dropdowns on desktop
document.querySelectorAll(".navbar-nav a.dropdown-toggle").forEach((item) => {
    item.addEventListener("click", (e) => {
        //prevent propagation
        e.stopPropagation();

        //get the href attribute
        const href = item.getAttribute("href");
        if (href === "#") {
            return;
        }

        //find the element with the class .offcanvas-start in the element's parent tree
        const offcanvasStart = item.closest(".offcanvas-start");
        if (!offcanvasStart) {
            return;
        }

        //check if the offcanvas has the show class
        const isOffcanvasShown = offcanvasStart.classList.contains("show");
        if (isOffcanvasShown) {
            return;
        }

        //go to the href
        window.location.href = href;
    });
});

//when the mobile menu is shown, check the position
let navbarToggler = document.querySelector(".navbar-toggler");
if (navbarToggler) {
    navbarToggler.addEventListener("click", () => {
        //get the .header-inner element
        let headerInner = document.querySelector(
            "#wrapper-navbar .header-inner",
        );
        if (!headerInner) {
            return;
        }

        //get the vertical position of the button relative to the window
        let pozY = navbarToggler.getBoundingClientRect().top;

        if (!pozY) {
            return;
        }

        if (pozY < 30) {
            //add class .scrolling to the .header-inner element
            headerInner.classList.add("scrolling");
        } else {
            //remove class .scrolling from the .header-inner element
            headerInner.classList.remove("scrolling");
        }
    });
}

// Hero background parallax effect
function initHeroParallax() {
    const hero = document.getElementById("home-hero");
    if (!hero) {
        return;
    }

    window.addEventListener("scroll", () => {
        const scrolled = window.pageYOffset;
        const heroHeight = hero.offsetHeight;

        // Only apply parallax while hero is visible
        if (scrolled <= heroHeight) {
            const parallaxSpeed = 0.5; // Adjust this value (0-1) for parallax intensity
            hero.style.backgroundPositionY = scrolled * parallaxSpeed + "px";
        }
    });
}
initHeroParallax();

// Animate home services cards on scroll
function initServiceCardsAnimation() {
    const serviceCards = document.querySelectorAll(
        "#home-services .service-card",
    );

    if (!serviceCards.length) {
        return;
    }

    observeReveal(serviceCards, {
        threshold: 0.1,
        rootMargin: "0px 0px 50px 0px",
        delayPerItem: 0.15,
        delayModulo: 3,
    });
}
initServiceCardsAnimation();

// Animate about section image on scroll
function initAboutImageAnimation() {
    const imageContainer = document.querySelector(
        "#home-about .side-img-container",
    );

    if (!imageContainer) {
        return;
    }

    observeReveal([imageContainer], {
        threshold: 0.2,
        rootMargin: "0px",
    });
}
initAboutImageAnimation();

// Animate home why cards on scroll
function initWhyCardsAnimation() {
    const whyCards = document.querySelectorAll("#home-why .why-card");

    if (!whyCards.length) {
        return;
    }

    observeReveal(whyCards, {
        threshold: 0.1,
        rootMargin: "0px 0px 50px 0px",
        delayPerItem: 0.15,
        delayModulo: 3,
    });
}
initWhyCardsAnimation();

function initFleetAnimation() {
    const fleetSection = document.getElementById("home-fleet");
    if (!fleetSection) {
        return;
    }

    const fleetTitle = fleetSection.querySelector(".fleet-title");
    const fleetCopy = fleetSection.querySelectorAll(".fleet-copy p");
    const fleetCards = fleetSection.querySelectorAll(".fleet-item");

    animateEntryElementGroups([
        {
            elements: fleetTitle ? [fleetTitle] : [],
            delayStep: 0.12,
        },
        {
            elements: [...fleetCopy],
            delayStep: 0.12,
        },
    ]);

    observeReveal(fleetCards, {
        threshold: 0.12,
        rootMargin: "0px 0px 40px 0px",
        delayPerItem: 0.12,
        delayModulo: 2,
    });
}
initFleetAnimation();

function initTreesAnimation() {
    const treesSection = document.getElementById("home-trees");
    if (!treesSection) {
        return;
    }

    const entryElements = [
        treesSection.querySelector(".home-trees-label"),
        treesSection.querySelector("h2"),
        ...treesSection.querySelectorAll(".home-trees-copy"),
        treesSection.querySelector(".home-trees-action .fa-btn"),
    ].filter(Boolean);

    const speciesPills = treesSection.querySelectorAll(
        ".home-trees-species-pill",
    );
    const treesNote = treesSection.querySelector(".home-trees-note");

    animateEntryElements(entryElements, { delayStep: 0.1 });

    observeReveal(speciesPills, {
        threshold: 0.12,
        rootMargin: "0px 0px 40px 0px",
        delayPerItem: 0.07,
    });

    if (treesNote) {
        observeReveal([treesNote], {
            threshold: 0.12,
            rootMargin: "0px 0px 30px 0px",
        });
    }
}
initTreesAnimation();

function initClimateAnimation() {
    const climateSection = document.getElementById("home-climate");
    if (!climateSection) {
        return;
    }

    const entryElements = [
        climateSection.querySelector(".home-climate-intro .pre-title"),
        climateSection.querySelector(".home-climate-intro h2"),
        climateSection.querySelector(".home-climate-intro p"),
        climateSection.querySelector(".climate-risk-title"),
    ].filter(Boolean);

    const mainTableRows = climateSection.querySelectorAll(
        ".climate-main-table-wrap tbody tr",
    );
    const riskTableRows = climateSection.querySelectorAll(
        ".climate-risk-table-wrap tbody tr",
    );

    animateEntryElements(entryElements, { delayStep: 0.1 });

    observeReveal(mainTableRows, {
        threshold: 0.12,
        rootMargin: "0px 0px 30px 0px",
        delayPerItem: 0.03,
    });

    observeReveal(riskTableRows, {
        threshold: 0.12,
        rootMargin: "0px 0px 30px 0px",
        delayPerItem: 0.08,
    });
}
initClimateAnimation();

function initInsuranceAnimation() {
    const insuranceSection = document.getElementById("home-insurance");
    if (!insuranceSection) {
        return;
    }

    const introElements = [
        insuranceSection.querySelector(".insurance-intro .pre-title"),
        insuranceSection.querySelector(".insurance-intro h2"),
        insuranceSection.querySelector(".insurance-intro p"),
    ].filter(Boolean);

    const detailCopyElements = [
        insuranceSection.querySelector(
            ".insurance-bottom-copy .insurance-detail-title",
        ),
        ...insuranceSection.querySelectorAll(".insurance-bottom-copy p"),
    ].filter(Boolean);

    const insuranceCards = insuranceSection.querySelectorAll(
        ".insurance-grid .insurance-item",
    );
    const insuranceSteps = insuranceSection.querySelectorAll(
        ".insurance-bottom-steps .step-row",
    );
    const insuranceStepsContainer = insuranceSection.querySelector(
        ".insurance-bottom-steps",
    );

    const playInsuranceStepsAnimation = () => {
        insuranceSteps.forEach((step) => {
            step.classList.remove("animate-in");
        });

        if (insuranceSteps.length) {
            // Force a reflow so the same keyframe animation can replay on re-entry.
            void insuranceSteps[0].offsetWidth;
        }

        insuranceSteps.forEach((step, index) => {
            step.style.animationDelay = `${index * 0.1}s`;
            step.classList.add("animate-in");
        });
    };

    animateEntryElementGroups([
        {
            elements: introElements,
            delayStep: 0.1,
        },
        {
            elements: detailCopyElements,
            delayStep: 0.12,
        },
    ]);

    observeReveal(insuranceCards, {
        threshold: 0.12,
        rootMargin: "0px 0px 40px 0px",
        delayPerItem: 0.1,
        delayModulo: 4,
    });

    if (prefersReducedMotion) {
        insuranceSteps.forEach((step) => {
            step.classList.add("animate-in");
        });
        return;
    }

    if (!insuranceSteps.length || !insuranceStepsContainer) {
        return;
    }

    if (typeof IntersectionObserver === "undefined") {
        playInsuranceStepsAnimation();
        return;
    }

    let stepsAreInView = false;
    const stepsObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!stepsAreInView) {
                        playInsuranceStepsAnimation();
                    }
                    stepsAreInView = true;
                } else {
                    stepsAreInView = false;
                }
            });
        },
        {
            root: null,
            threshold: 0.22,
            rootMargin: "0px 0px -5% 0px",
        },
    );

    stepsObserver.observe(insuranceStepsContainer);
}
initInsuranceAnimation();

function initRegulationsAnimation() {
    const regulationsSection = document.getElementById("home-regulations");
    if (!regulationsSection) {
        return;
    }

    const entryElements = [
        regulationsSection.querySelector(".regulations-label"),
        regulationsSection.querySelector(".regulations-title"),
        ...regulationsSection.querySelectorAll(".regulations-copy p"),
    ].filter(Boolean);

    const panelElements = regulationsSection.querySelectorAll(
        ".regulations-panels .regulations-card, .regulations-panels .regulations-note",
    );

    animateEntryElements(entryElements, { delayStep: 0.1 });

    observeReveal(panelElements, {
        threshold: 0.12,
        rootMargin: "0px 0px 30px 0px",
        delayPerItem: 0.1,
    });
}
initRegulationsAnimation();
